import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum ProblematicEntityType {
    Buyers = 'buyers',
    Invoices = 'invoices',
    Payments = 'payments',
}

export const ProblematicEntityTypeSchema = EnumSchema(ProblematicEntityType);

export const ProblematicEntityRowSchema = z
    .object({
        id: z.string(),
        status: z.string(),
        syncUpStatus: z.string().optional(),
        message: z.string().nullish(),
        referenceId: z.string().optional(),
        updatedAt: z.string().optional(),
    })
    .strict();

export interface ProblematicEntityRow extends z.infer<typeof ProblematicEntityRowSchema> {}
